import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { BrandLogo } from "../components/Layout";

const OtpBoxes = ({ value, onChange, testId }) => (
  <InputOTP maxLength={6} value={value} onChange={onChange} data-testid={testId}>
    <InputOTPGroup className="gap-2">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <InputOTPSlot key={i} index={i} className="h-12 w-11 rounded-xl border text-lg font-semibold first:rounded-l-xl last:rounded-r-xl" />
      ))}
    </InputOTPGroup>
  </InputOTP>
);

export default function SetPin() {
  const { user, setPin } = useAuth();
  const navigate = useNavigate();
  const [pin, setPinValue] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (pin.length !== 6) return;
    if (pin !== confirm) {
      toast.error("PIN tidak sama. Periksa kembali.");
      setConfirm("");
      return;
    }
    setLoading(true);
    try {
      await setPin(pin);
      toast.success("PIN berhasil diatur! Selamat bertransaksi.");
      navigate("/");
    } catch (err) {
      toast.error(errMsg(err, "Gagal mengatur PIN"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-dvh flex items-center justify-center bg-background p-6">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }} className="w-full max-w-md">
        <div className="mb-8 text-center">
          <BrandLogo />
        </div>
        <Card className="rounded-2xl shadow-[0_10px_30px_rgba(11,18,32,0.08)]">
          <CardContent className="p-6 sm:p-8 text-center">
            <div className="mx-auto h-14 w-14 rounded-full bg-primary/10 flex items-center justify-center mb-4">
              <Lock className="h-7 w-7 text-primary" />
            </div>
            <h2 className="font-heading text-2xl font-semibold mb-1">Atur PIN Transaksi</h2>
            <p className="text-sm text-muted-foreground mb-8">
              Halo {user?.name?.split(" ")[0]}! PIN 6 digit ini akan diminta setiap kali kamu mengirim uang.
            </p>
            <div className="space-y-6">
              <div className="space-y-2">
                <p className="text-sm font-medium text-left">PIN Baru</p>
                <div className="flex justify-center">
                  <OtpBoxes value={pin} onChange={setPinValue} testId="setpin-pin-input" />
                </div>
              </div>
              <div className="space-y-2">
                <p className="text-sm font-medium text-left">Ulangi PIN</p>
                <div className="flex justify-center">
                  <OtpBoxes value={confirm} onChange={setConfirm} testId="setpin-confirm-input" />
                </div>
              </div>
              <Button className="w-full h-11 text-base" onClick={submit} disabled={pin.length !== 6 || confirm.length !== 6 || loading} data-testid="setpin-submit-button">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Simpan PIN"}
              </Button>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}
